import {ILocaleProperties} from "./locale-models";
import {Pipe, PipeTransform} from "@angular/core";
import * as _ from 'lodash';

@Pipe({
    name: 'localeFilter',
    standalone: false
})
export class LocaleFilterPipe implements PipeTransform {
    transform(itemsArray: any, search: string) {
        const filteredItems = [];
        if ((!_.isString(search)) || (search.length < 1)) {
            return itemsArray;
        }
        _.forEach(itemsArray, (items) => {
            const filtered = [];
            const searchRegex = new RegExp(search, 'i');
    
            _.forEach(items, (value: ILocaleProperties) => {
                if (value.usanaLocale.match(searchRegex) || value.languageDisplay.match(searchRegex) || value.countryDisplay.match(searchRegex)) {
                    filtered.push(value);
                }
            });
            filteredItems.push(filtered);
        });
        return filteredItems;
    }
}
